module.exports = __webpack_public_path__ + "overview-d35a4493/404-6b5a631fccc0149f72dd5d37e01692c7.svg";